import { FC, SVGProps } from 'react';

export const MsTeamsLogo: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" fill="currentColor" aria-hidden="true" focusable="false" {...props}>
		{/* Rounded square with T cut out via evenodd rule */}
		<path
			fillRule="evenodd"
			d="M14,0 H86 A14,14 0 0 1 100,14 V86 A14,14 0 0 1 86,100 H14 A14,14 0 0 1 0,86 V14 A14,14 0 0 1 14,0 Z M16,18 H84 V30 H58 V82 H42 V30 H16 Z"
		/>
	</svg>
);
